/**
 * Public API Surface of FleetStatsApi functions
 */

export * from './get-dashboard-account-stats-assets';
export * from './get-dashboard-account-stats-export-tta-assets';
export * from './get-dashboard-account-stats-time-to-activate-asset';
export * from './get-dashboard-account-stats';
export * from './get-dashboard-avoid-favor-stats';
export * from './get-dashboard-custom-places-stats';
export * from './get-dashboard-device-stats-device-location-details';
export * from './get-dashboard-device-stats-devices-with-older-map-set-data';
export * from './get-dashboard-device-stats-minutes-saved-using-traffic-data';
export * from './get-dashboard-device-stats-rollover-events';
export * from './get-dashboard-device-stats-weather-events';
export * from './get-dashboard-routing-profile-stats';
export * from './get-dashboard-vehicle-stats-unassigned-configuration-profiles';
export * from './get-dashboard-vehicle-stats-unassigned-routing-profiles';
export * from './get-dashboard-vehicle-stats-unassigned-vehicle-groups';
